export default {
  title: 'light',
  background: '#f8f9fa',
  color: '#444',
  inverseColor: '#f8f9fa',
  primary: '#444',
};
